import axios from "axios";

const ENTERPRISE_PORTAL_REGEX = /^enterpriseportal-.*\.accuweather\.com$/;

axios.interceptors.request.use((config) => {
  const url = config.url || "";

  // Only process absolute URLs
  if (typeof url !== "string" || !url.startsWith("http")) {
    return config;
  }

  try {
    const requestUrl = new URL(url);
    const currentHost = window.location.host;

    // Only rewrite enterpriseportal-* domains
    if (
      ENTERPRISE_PORTAL_REGEX.test(requestUrl.host) &&
      requestUrl.host !== currentHost
    ) {
      config.url = requestUrl.pathname + requestUrl.search;
    }
  } catch (e) {
    return config;
  }

  return config;
});